import React from "react";
import { LoadingSpinner } from "../ui/LoadingSpinner";

/**
 * PageLoadingView - Single source of truth for full-page loading states.
 * Used for Suspense fallbacks and in-page data loading (when isLoading is true).
 * For inline/small loading (buttons, search bars), use LoadingSpinner directly.
 */
export const PageLoadingView: React.FC = () => {
  return (
    <div className="flex justify-center items-center min-h-[60vh]">
      <LoadingSpinner size="lg" color="primary" />
    </div>
  );
};
